import axios, { AxiosResponse } from 'axios'
import { IBankTransaction } from './BankTransactionModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'

// Base URL ayarı
const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

//  BASE URL
export const BANK_TRANSACTION_CREATE_URL = `${API_URL}api/v1/definition/bankTransaction/create`
export const BANK_TRANSACTION_GET_ALL_URL = `${API_URL}api/v1/definition/bankTransaction/all`
export const BANK_TRANSACTION_DELETE_URL = `${API_URL}api/v1/definition/bankTransaction/delete/`
export const BANK_TRANSACTION_UPDATE_URL = `${API_URL}api/v1/definition/bankTransaction/update/`

export function createBankTransaction(BankTransactionData: IBankTransaction) {
    return axios.post(BANK_TRANSACTION_CREATE_URL, BankTransactionData)
}

export function updateBankTransaction(BankTransactionData: IBankTransaction) {
    return axios.post(BANK_TRANSACTION_UPDATE_URL + BankTransactionData.id, BankTransactionData)
}

export async function loadBankTransactions(
    page = 0,
    size = 5,
    sort: string = 'createdDate',
    order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IBankTransaction>>>> {
    return axios.get(BANK_TRANSACTION_GET_ALL_URL, {
        params: { page, size, sort, order },
    })
}

export function deleteBankTransaction(BankTransactionId: string) {
    return axios.post(BANK_TRANSACTION_DELETE_URL + BankTransactionId)
}
